<template>
  <div id="oneclick" class="word-break-keep-all">
    <section id="hero">
      <div class="container">
        <p>원클릭 사업검토</p>
        <h1 class="title">한 번에 분석하는 RPS 사업검토로<br>업무 효율이 높아집니다</h1>
        <button type="button" class="hz-btn-default hz-btn-lg" @click="scrollToTutorial">튜토리얼 보기</button>
      </div>
    </section>
    <section id="search">
      <div class="container">
        <div class="row">
          <div class="col-lg-offset-3 col-lg-6 col-md-offset-2  col-md-8 padding-0">
            <div v-if="!user.id" style="position: absolute; width: 100%; height: 100%; z-index: 5;" @click="showLoginModal"></div>
            <index-input-address ref="inputAddress" v-model="address"></index-input-address>
            <button type="button" v-show="address.length === 0" @click="search">검색하기</button>
            <button type="button" v-show="address.length > 1" @click="review">검토하기</button>
            <div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="list" v-if="user.id">
      <div class="container">
        <div class="search-wrap" v-if="user.auth_level === '90'">
          <div class="row">
            <div class="col-sm-4">
              <div class="checkbox">
                <label>
                  <input type="checkbox" v-model="companyAllCheck" @change="retrieveOthers">
                  <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                  해줌 전체
                </label>
              </div>
            </div>
            <div class="col-sm-8 text-right">
              <input type="text" class="hz-input-default hz-input-md" maxlength="100" placeholder="검색할 프로젝트명을 입력해주세요." v-model="searchText" @keypress.prevent.enter="searchProject">
              <button type="button" class="hz-btn-primary hz-btn-md" @click="searchProject">검색하기</button>
            </div>
          </div>
        </div>
        <kendo-grid ref="grid"
                    :columns="tableFields"
                    :options="tableOptions"
                    :auth="true"
                    :dataUrl="dataUrl"
                    :message="'저장된 보고서가 없습니다.'" :dblClickRow="viewDetail"></kendo-grid>
      </div>
    </section>
    <section id="problem">
      <div class="container">
        <h2 class="title">아직도 복잡하게<br>사업검토 하시나요?</h2>
        <p class="description">필요한 정보 찾으러 여러 사이트를 확인할 필요가 없습니다.</p>
        <img src="~@/assets/img/oneclick/img-oneclick-problem-01@2x.png" class="img-responsive">
      </div>
    </section>
    <section id="benefit">
      <div class="container">
        <h2 class="title">원클릭 사업검토 하나면<br>5분 안에 끝!</h2>
        <ul class="row nav nav-tabs">
          <li class="col-xs-4 active">
            <a href="#benefit1" data-toggle="tab">부지정보</a>
          </li>
          <li class="col-xs-4">
            <a href="#benefit2" data-toggle="tab">발전정보</a>
          </li>
          <li class="col-xs-4">
            <a href="#benefit3" data-toggle="tab">수익정보</a>
          </li>
        </ul>
        <div class="row">
          <div class="tab-content col-md-offset-1 col-md-10">
            <div id="benefit1" class="tab-pane fade in active">
              <div class="tab-pane-header">
                <p class="description">10개 주소 동시 분석<br>부지정보, 조례정보, 전력계통정보 등</p>
              </div>
              <div class="tab-pane-body">
                <video muted playsinline>
                  <source :src="landVideoUrl" type="video/mp4">
                  비디오 재생을 지원하지 않는 브라우저 입니다.
                </video>
              </div>
            </div>
            <div id="benefit2" class="tab-pane fade in">
              <div class="tab-pane-header">
                <p class="description">해줌 AI 기술로 발전량 분석<br>발전량, 온도/일사량 등</p>
              </div>
              <div class="tab-pane-body">
                <video muted playsinline>
                  <source :src="analysisVideoUrl" type="video/mp4">
                  비디오 재생을 지원하지 않는 브라우저 입니다.
                </video>
              </div>
            </div>
            <div id="benefit3" class="tab-pane fade in">
              <div class="tab-pane-header">
                <p class="description">20개 조건별 수익 분석<br>투자회수기간, 수익률, 연도별 자금흐름표 등</p>
              </div>
              <div class="tab-pane-body ">
                <video muted playsinline>
                  <source :src="profitVideoUrl" type="video/mp4">
                  비디오 재생을 지원하지 않는 브라우저 입니다.
                </video>
              </div>
            </div>
            <img src="~@/assets/img/img-video-border.png" class="video-border">
          </div>
        </div>
      </div>
    </section>
    <!-- 보고서 생성 알림창 -->
    <modal ref="createModal" :id="createModal.id" :type="createModal.type"
           :title="createModal.title" :size="createModal.size" :fields="createModal.fields"
           @submit="$router.push({name: 'extendNew', params: { id: selectReportId, new: true }})"></modal>
    <!-- 보고서 삭제 알림창 -->
    <modal ref="removeModal" :id="removeModal.id" :type="removeModal.type" :title="removeModal.title"
           :size="removeModal.size" :fields="removeModal.fields" @submit="removeReport"></modal>
  </div>
</template>

<script>
  import api from '@/api/index'
  import IndexInputAddress from '@/components/IndexInputAddress'
  import KendoGrid from 'common/components/KendoGrid'
  import Modal from 'common/components/Modal'
  import eventHub from '@/shared/EventHub'
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'oneclick',
    components: {
      IndexInputAddress,
      KendoGrid,
      Modal
    },
    data: function () {
      return {
        address: '',
        currentTab: 'landInfo',
        searchText: '',
        dataUrl: location.protocol + '//' + location.hostname.replace('biz', 'api') + '/biz/review/list/',
        landVideoUrl: require('../../assets/video/oneclick/video-oneclick-benefit-land.mp4'),
        analysisVideoUrl: require('../../assets/video/oneclick/video-oneclick-benefit-analysis.mp4'),
        profitVideoUrl: require('../../assets/video/oneclick/video-oneclick-benefit-profit.mp4'),
        companyAllCheck: false,
        tableFields: [
          {
            field: 'project_name',
            title: '프로젝트명',
            type: 'string',
            width: '250px',
            attributes: { class: 'show-tooltip' },
            sortable: false,
            filterable: false
          },
          {
            field: 'reg_date',
            title: '저장일',
            type: 'date',
            format: '{0:yyyy.MM.dd}',
            width: '120px',
            sortable: false,
            filterable: false
          },
          {
            field: 'capacity',
            title: '용량(kWp)',
            type: 'number',
            width: '100px',
            sortable: false,
            filterable: false,
            template: function (dataItem) {
              const capacity = dataItem.oneclick_profit_condition.expect_capacity
              return capacity
            }
          },
          {
            field: 'reg_by__first_name',
            title: '회사명',
            type: 'string',
            width: '150px',
            attributes: { class: 'show-tooltip' },
            sortable: false,
            filterable: false
          },
          {
            field: 'oneclick_user',
            title: '담당자',
            type: 'string',
            width: '120px',
            sortable: false,
            filterable: false
          },
          {
            field: 'oneclick_grade',
            title: '평가',
            type: 'string',
            width: '80px',
            sortable: false,
            filterable: false,
            template: function (dataItem) {
              let template = ''
              const state = dataItem.oneclick_grade
              // 단독주택 서비스 일 경우
              if (state === '가능') {
                template = `<div class='state-tag possible-tag'>가능</div>`
              } else if (state === '불가') {
                template = `<div class='state-tag impossible-tag'>불가</div>`
              } else if (state === '보류') {
                template = `<div class='state-tag hold-tag'>보류</div>`
              } else {
                template = `<div class='state-tag'>미정</div>`
              }
              return template
            }
          },
          {
            field: 'oneclick',
            title: '원클릭사업검토',
            type: 'string',
            width: '120px',
            sortable: false,
            filterable: false,
            template: function (dataItem) {
              return `<i rpid='${dataItem['id']}' type='oneclick'
                        class='glyphicon glyphicon-download-alt' style='cursor: pointer; font-weight: bold;'></i>`
            }
          },
          {
            field: 'extend',
            title: '프리미엄보고서',
            type: 'string',
            width: '120px',
            sortable: false,
            filterable: false,
            template: function (dataItem) {
              let template = ''
              if (dataItem['extend_status'] === 'U') {
                template = `<i rpid='${dataItem['id']}' type='extend'
                        class='glyphicon glyphicon-download-alt' style='cursor: pointer; font-weight: bold;'></i>`
              } else {
                template = `<i rpid='${dataItem['id']}' type='extend'
                        class='glyphicon glyphicon-pencil' style='cursor: pointer; font-weight: bold;'></i>`
              }
              return template
            }
          },
          {
            field: 'delete',
            title: '삭제',
            type: 'string',
            width: '80px',
            sortable: false,
            filterable: false,
            template: function (dataItem) {
              return `<div rpid="${dataItem['id']}" regby="${dataItem['reg_by']}" title="${dataItem['project_name']}" class="k-grid-remove" style="cursor: pointer;">☓</div>`
            }
          }
        ],
        tableOptions: {
          parameter: [
            { name: 'all_check', value: 'N' },
            { name: 'project_name', value: '' }
          ],
          pageable: {
            info: true,
            previousNext: true,
            numeric: true,
            pageSize: 20,
            pageSizes: [20, 50, 100, 'all'],
            refresh: true,
            buttonCount: 5,
            messages: {
              itemsPerPage: '페이지당 항목수'
            }
          }
        },
        selectReportId: '',
        createModal: {
          id: 'createModal',
          type: 'confirm',
          title: '보고서 생성',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['프리미엄 보고서를 생성하시겠습니까?'],
              class: 'text-center'
            }
          ]
        },
        removeModal: {
          id: 'removeModal',
          type: 'confirm',
          title: '보고서 삭제',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: [],
              class: 'text-center'
            }
          ]
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'user',
        isPaidMember: 'isPaidMember'
      })
    },
    watch: {
      'user': {
        handler (val) {
          // 로그인한 유저 일 경우, 해당 페이지에 접근권한이 있는지를 확인한다.
          if (typeof val.id !== 'undefined') {
            this.$store.dispatch('checkAccessMenu')
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'showToastMessage'
      ]),
      scrollToTutorial () {
        const position = document.querySelector('#benefit .nav-tabs').offsetTop - 80
        $('html,body').stop().animate({scrollTop: (position)}, 500)
      },
      showLoginModal () {
        // Main.vue로 이벤트 전달
        eventHub.$emit('showLoginModal')
      },
      search () {
        // 입력필드에 입력된 주소지에 상세정보를 검색한다.
        this.$refs.inputAddress.onSearch()
      },
      review () {
        // 검색 된 주소목록이 있을 경우, 파라미터에 주소정보를 담아 원클릭보고서 페이지로 이동
        const address = this.address
        if (address) {
          this.$router.push({name: 'oneclickNew', params: { address: address }})
        }
      },
      viewDetail (id, type, preview = false) {
        /**
         * 보고서 상세보기를 실행하는 함수입니다.
         * 두가지 상황에 이벤트가 발생합니다.
         * 1. 보고서 목록에서 row 더블클릭 (Object 형태에 보고서 데이터가 전달됨)
         * 2. 보고서 다운로드 아이콘 클릭 (String 형태에 보고서 유형 플래그가 전달됨)
         * data 파라미터에 타입이 스트링인지 오브젝트인지에 따라 동작을 구분합니다.
         */

        // 더블클릭 이벤트 일 경우
        const isDblClick = typeof type === 'object'
        if (isDblClick) {
          this.$router.push({name: 'oneclickLoad', params: {id: id}})
          return false
        }

        // 다운로드 아이콘 이벤트 일 경우
        if (preview) {
          this.$router.push({name: `${type}Load`, params: {id: id, preview: true}})
          return false
        }

        // 그 외 경우에는, 유료회원인지 확인한다.
        if (type === 'extend') {
          if (this.isPaidMember) {
            this.selectReportId = id
            this.$refs.createModal.show()
          } else {
            eventHub.$emit('showChargeModal')
            return false
          }
        }
      },
      setDownloadEvent () {
        $(document).on('click', '.kendo-grid tbody tr .glyphicon', (e) => {
          console.log(new Date())
          const id = e.target.getAttribute('rpid')
          const type = e.target.getAttribute('type')
          const isDownload = e.target.classList.contains('glyphicon-download-alt')

          this.viewDetail(id, type, isDownload)
        })
      },
      setRemoveEvent () {
        $(document).on('click', '.kendo-grid tbody tr .k-grid-remove', (e) => {
          const target = e.target
          const registerUser = parseInt(target.getAttribute('regby'))
          const currentUser = parseInt(this.user.id)

          // 로그인한 사용자가 보고서 작성자와 동일한지 확인
          if (registerUser === currentUser) {
            this.selectReportId = target.getAttribute('rpid')
            this.removeModal.fields[0].message = [target.title + ' 보고서를 삭제하시겠습니까?']
            this.$refs.removeModal.show()
          } else {
            alert('본인이 작성한 보고서가 아닙니다.')
          }
        })
      },
      removeReport () {
        api.removeReport(this.selectReportId, response => {
          if (response.error) {
            this.showToastMessage('보고서 삭제실패')
          } else {
            this.showToastMessage('보고서 삭제완료')
            this.$refs.grid.refresh()
          }
        })
      },
      retrieveOthers () {
        // 보고서 전체보기 클릭 여부에 따라 목록 API Parameter를 설정해준다.
        const isAll = this.companyAllCheck ? 'Y' : 'N'

        this.tableOptions.parameter[0].value = isAll
        this.$refs.grid.refresh()
      },
      searchProject () {
        const text = this.searchText

        // 보고서 프로젝트명 검색 클릭 시 API Parameter를 설정해준다.
        this.tableOptions.parameter[1].value = text
        this.$refs.grid.refresh()
      },
      playVideoOnBenefitSection () {
        // 지정된 영역에 스크롤이 있을 경우 비디오를 재생한다.
        // 지정된 영역을 벗어날 경우 비디오를 멈춘다.
        const benefit = document.querySelector('#benefit')
        const video = benefit.querySelector('.tab-pane.active video')
        const targetPositionY = benefit.offsetTop - 64
        const currentPositionY = window.scrollY
        const isPlayPosition = targetPositionY < currentPositionY

        if (isPlayPosition && video.paused) {
          video.play()
        } else if (!isPlayPosition && !video.paused) {
          video.pause()
        }
      }
    },
    created () {
      const token = localStorage.getItem('_t')

      // 토큰이 있을 경우, 토큰의 유호성을 검사한다.
      if (token) {
        this.$store.dispatch('inspectToken', token).then(() => {
          // 유효한 토큰 일 경우 보고서 이동, 삭제 이벤트를 등록해준다.
          this.$nextTick(() => {
            this.setDownloadEvent()
            this.setRemoveEvent()
          })
        })
      }
    },
    mounted () {
      // 로그인한 유저 일 경우, 해당 페이지에 접근권한이 있는지를 확인한다.
      if (typeof this.user.id !== 'undefined') {
        this.$store.dispatch('checkAccessMenu')
      }

      // 영상 자동재생 이벤트 리스너
      window.addEventListener('scroll', this.playVideoOnBenefitSection)

      $('#benefit a[data-toggle="tab"]').on('shown.bs.tab', () => {
        document.querySelector('#benefit .tab-pane.active video').play()
      })

      $('#benefit a[data-toggle="tab"]').on('hide.bs.tab', () => {
        const video = document.querySelector('#benefit .tab-pane.active video')
        video.currentTime = 0
        video.pause()
      })
    },
    beforeDestroy () {
      // 엘리먼트 및 이벤트 초기화
      kendo.destroy(document.body)
      window.removeEventListener('scroll', this.playVideoOnBenefitSection)
      $(document).off('click', '.kendo-grid tbody tr .glyphicon')
      $(document).off('click', '.kendo-grid tbody tr .k-grid-remove')
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/pages/index_report';
  @import '~@/assets/css/components/tab';

  #hero {
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-image: url("../../assets/img/oneclick/hero-oneclick-lg@2x.jpg");

    .container {
      padding: 95px 0 95px 96px;
    }

    h1 {
      color: $hzc-white;
    }

    p {
      margin: 0 0 24px;
      color: $orange;
    }

    @media (max-width: $screen-xs-max) {
      text-align: center;

      .container {
        padding: 84px 16px;
      }
    }
  }

  #benefit {
    .nav-tabs {
      max-width: 360px;
    }

    .video-border {
      position: absolute;
      top: 96px;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% + 32px);
      height: calc(100% - 96px);

      @media (max-width: $screen-xs-max) {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/oneclick/OneClick.vue